import { isBrowser } from "utils/helpers";
import AdminService from "./Admin";
import APIBaseService from "./APIBase";
import { HTTP_METHOD } from "./APIBase.d";
import { User } from "./User.d";

export const otpRequiredString = "Needs OTP";
export const invalidOtpString = "Invalid OTP";

export const localStorageUserName = "foreSiteUser";

class UserService extends APIBaseService {
  protected accessToken: string | null;
  endpoint = "user";

  constructor() {
    super();
    this.accessToken = this.getAccessToken();
  }

  getUserGroupID = async (
    username?: string,
    userOtp?: string
  ): Promise<string | null> => {
    const res = await this.call(
      `groupID/${username}`,
      HTTP_METHOD.GET,
      null,
      userOtp
    );

    if (res.response?.data?.message?.error === otpRequiredString) {
      return otpRequiredString;
    }

    if (res.response?.data?.message?.error === invalidOtpString) {
      return invalidOtpString;
    }

    return res.data.message.groupID;
  };

  getUserInfo = async (
    username: string,
    groupID: string | null,
    userOtp?: string | null
  ): Promise<User> => {
    const req = await this.call(
      `info/${username}/${groupID}`,
      HTTP_METHOD.GET,
      null,
      userOtp
    );
    const res = req.data.message;
    const user = res.user;
    this.setUser(user);
    return user;
  };

  public getUser = () => {
    const item = window.localStorage.getItem(localStorageUserName);
    if (isBrowser() && item) {
      return JSON.parse(item);
    } else return null;
  };

  public resetUser = () => {
    if (isBrowser()) {
      window.localStorage.removeItem(localStorageUserName);
    }
  };

  getAccessToken(): string | null {
    if (this.USER_KEY && isBrowser()) {
      return String(window.sessionStorage.getItem(this.USER_KEY));
    }
    return null;
  }
  private setGroupID = (id: string | null) => {
    isBrowser() && id && window.sessionStorage.setItem("groupID", id);
  };
  public setUser = (user: User | string) => {
    isBrowser() &&
      user &&
      window.localStorage.setItem(localStorageUserName, JSON.stringify(user));
  };
}

export const getUserCPFOptions = (user) => {
  const adminService = new AdminService();
  return new Promise((resolve, reject) => {
    adminService
      .getUserCPF(user?.username, user?.groupID?.toString())
      .then((res) => {
        if (res.message.CPFSet[0].CPFs) {
          const filteredArray = Array.from(
            new Set(res.message.CPFSet[0].CPFs)
          ).filter(
            (item: any) => item !== "" && item !== undefined && item !== null
          ) as string[];
          resolve(filteredArray);
        }
        resolve([]);
      })
      .catch(() => {
        resolve([]);
      });
  });
};

export default UserService;
